import React from 'react';
import { Hero } from '../components/home/Hero';
import { FeatureStrip } from '../components/home/FeatureStrip';
import { TheMaskSection } from '../components/home/TheMaskSection';
import { WavelengthStory } from '../components/home/WavelengthStory';
import { LightScience } from '../components/home/LightScience';
import { ScrollStory } from '../components/home/ScrollStory';
import { KitSection } from '../components/home/KitSection';
import { ProductDetails } from '../components/home/ProductDetails';
import { FaqSection } from '../components/home/FaqSection';
import { ClosingInvitation } from '../components/home/ClosingInvitation';
export function Home() {
  return <>
      <Hero data-id="element-595" data-mp="2dhywio1gjitm" />
      <FeatureStrip data-id="element-596" data-mp="2dirsctyvonwz" />
      <TheMaskSection data-id="element-597" data-mp="2dj1m8sn1nf7y" />
      <WavelengthStory data-id="element-598" data-mp="2dfdthvpfawua" />
      <LightScience data-id="element-599" data-mp="3kvtl5drznpxf" />
      <ScrollStory data-id="element-600" data-mp="3ku8tbvx26l39" />
      <KitSection data-id="element-601" data-mp="3kv0nd2b0carf" />
      <ProductDetails data-id="element-602" data-mp="3kxmtcxi92i7j" />
      <FaqSection data-id="element-603" data-mp="3owlyoj7w8gzi" />
      <ClosingInvitation data-id="element-604" data-mp="3ovub9vog9pkb" />
    </>;
}